import styled from "styled-components";

const StyledPortfolioView = styled.div`
  .page-content {
    background-color: ${({ theme }) => theme.color.gray[100]};
    min-height: 100vh;
    position: relative;
    z-index: ${({ theme }) => theme.elevation.backdrop};
  }
`;

export default StyledPortfolioView;
